export default __webpack_public_path__ + "static/media/moon.8129ab98.png";